import React, { useEffect, useRef, useState } from "react";
import { motion, animate } from "framer-motion";
import { fmt } from "@/lib/cee";

export const EASE = [0.16, 1, 0.3, 1];

export const MaskedLines = ({ lines, delay = 0, className = "", as: Tag = "h1" }) => (
  <Tag className={className}>
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className="block"
          initial={{ y: "115%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.95, delay: delay + i * 0.13, ease: EASE }}
        >
          {l}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const FadeIn = ({ children, delay = 0, y = 26, className = "", once = true }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.15 }}
    transition={{ duration: 0.75, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const AnimatedNumber = ({ value, decimals = 0, suffix = "" }) => {
  const [display, setDisplay] = useState(value || 0);
  const current = useRef(value || 0);
  useEffect(() => {
    const from = current.current;
    const controls = animate(from, value || 0, {
      duration: 0.7,
      ease: "easeOut",
      onUpdate: (v) => {
        current.current = v;
        setDisplay(v);
      },
    });
    return () => controls.stop();
  }, [value]);
  return (
    <span className="tnum">
      {fmt(display, decimals)}
      {suffix}
    </span>
  );
};
